import { SelectedData } from 'types/common/FormTypes';

export const transformOptionsToListsArray = (
  data: SelectedData[] | null | undefined
) => {
  if (!data || !Array.isArray(data)) {
    return [];
  }
  return data.map(({ value }) => (typeof value === 'string' ? value : ''));
};
export const transformOptionsToNumberArray = (
  data: SelectedData[] | null | undefined
) => {
  if (!data || !Array.isArray(data)) {
    return [];
  }
  return data.map(({ value }) => value);
};
export const transformArrayOptionsToStr = (
  data: SelectedData[] | null | undefined
) => {
  if (data && Array.isArray(data)) {
    return data.map(({ value }) => value).join(',');
  }
  return '';
};
export const transformArrayToStr = (data: string[] | null | undefined) => {
  if (data && Array.isArray(data)) {
    return data.join(',');
  }
  return '';
};
